/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_PrepaidInputs */

const en_plan_prepaid = /** @type {(inputs: Plan_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepaid access`)
};

const es_plan_prepaid = /** @type {(inputs: Plan_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso prepagado`)
};

/**
* | output |
* | --- |
* | "Prepaid access" |
*
* @param {Plan_PrepaidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_prepaid = /** @type {((inputs?: Plan_PrepaidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_PrepaidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_prepaid(inputs)
	return en_plan_prepaid(inputs)
});